import { AuthState } from '../../shared/interfaces/auth.interface'

import * as AuthActions from '../actions/auth.action'

import Services from '../../shared/services'

const userDefault = Services.storage.get('user') || null

const initialState: AuthState = {
  user: userDefault,
  success: false,
  loading: false,
}

const reducer = (state = initialState, action: { type: string; payload: AuthState }) => {
  const { type, payload } = action
  switch (type) {
    case AuthActions.AUTH_LOGIN:
      return {
        ...state,
        loading: true,
      }

    case AuthActions.AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        user: {
          email: payload.user.email,
        },
        success: payload.success,
        loading: false,
      }

    case AuthActions.AUTH_LOGIN_ERROR:
      return {
        ...state,
        loading: false,
      }

    case AuthActions.AUTH_LOGOUT:
      return {
        ...state,
      }

    case AuthActions.AUTH_LOGOUT_SUCCESS:
      return {
        ...state,
        user: null,
        success: false,
      }

    case AuthActions.AUTH_LOGOUT_ERROR:
      return {
        ...state,
      }

    case AuthActions.AUTH_OTP:
      return {
        ...state,
        loading: true,
      }

    case AuthActions.AUTH_OTP_SUCCESS:
      return {
        ...state,
        user: payload,
        loading: false,
      }

    case AuthActions.AUTH_OTP_ERROR:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}

export default reducer
